import styled from "styled-components";

export const MainContainer = styled.div`
    height: 100vh;
    width:100%;
    display: flex;
    overflow: auto;
    flex-direction: row;
`